import axios from "axios";

// const API_URL = "http://localhost:8000/"

const API_URL =
  process.env.NODE_ENV !== "production"
    ? "https://sbg.ingenioushitech.com/"
    : "https://sbg.ingenioushitech.com/";


const login = (username, password) => {
  return axios
    .post(API_URL + "api/admin/login", {
      userName: username,
      password: password,
    })
    .then((response) => {
      if (response?.data?.data?.accessToken) {
        localStorage.setItem("tUser", JSON.stringify(response?.data?.data?.userData));
        localStorage.setItem("tUserId", JSON.stringify(response?.data?.data?.userData?._id));
        localStorage.setItem(
          "tToken",
          JSON.stringify(response?.data?.data?.accessToken)
        );
      }
      return response?.data;
    });
};

const logout = () => {
  localStorage.removeItem("tUser");
  return axios.post(API_URL + "signout").then((response) => {
    return response?.data;
  });
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("tUser"));
};
const getCurrentUserTokken = () => {
  return JSON.parse(localStorage.getItem("tToken"));
};

const AuthService = {
  // register,
  login,
  logout,
  getCurrentUser,
  getCurrentUserTokken,
};

export default AuthService;
